import React, { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TextField, Autocomplete, CircularProgress } from '@mui/material';

import {
    sendSearch,
    clearSearchResult,
    getSearchType,
} from "features/pages/pagesSlice";

function SearchStringComponent({ title, value: filterValue, name, onChange, advancedOptions }) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [value, setValue] = React.useState(filterValue || null);
    const [inputValue, setInputValue] = useState(value?.name || "");
    const searchType = getSearchType(advancedOptions);
    const options = useSelector(state => state.pages.searchResult[searchType]);
    const loading = useSelector(state => state.pages.searchLoading[searchType]);

    const handleChange = (_, newValue) => {
        setValue(newValue);
        onChange && onChange({ name, value: newValue });
    }
    const handleInputChange = (_, newInputValue) => {
        const isChanged = inputValue !== newInputValue;

        setInputValue(newInputValue);

        if (newInputValue && newInputValue.length > 1 && isChanged) {
            dispatch(sendSearch({ text: newInputValue, advancedOptions }));
        }
    }

    const handleClose = () => {
        setOpen(false);
        dispatch(clearSearchResult(searchType));

        if (inputValue) {
            setInputValue("");
        }
    }

    return (
        <Autocomplete
            size='small'
            id={`search-string-${name}`}
            open={open}
            value={value || null}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onOpen={() => setOpen(true)}
            onClose={handleClose}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            options={options || []}
            loading={loading}
            clearText="Очистить"
            loadingText="загрузка..."
            noOptionsText="нет результатов"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={title}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            renderOption={(props, option) => <li {...props} key={option.id}>{option.name}</li>}
        />
    );
}

export const SearchString = memo(SearchStringComponent);
